import { render } from "./ChallengeView.vue?vue&type=template&id=4fe426cb&scoped=true"
import script from "./ChallengeView.vue?vue&type=script&lang=js"
export * from "./ChallengeView.vue?vue&type=script&lang=js"

import "./ChallengeView.vue?vue&type=style&index=0&id=4fe426cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe426cb"]])

export default __exports__